import { Fragment } from 'react';
import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Col, Grid, Image, Row, Space, Typography } from 'antd';
import ImageC from 'src/components/Image';
import classes from './MainFooter.module.less';
const {
  Paragraph
} = Typography;
const MainFooter = () => {
  const {
    xl,
    lg,
    xs
  } = Grid.useBreakpoint();
  const sosmed = {
    social_media: [{
      icon: '/images/default/Button-fb.png',
      name: 'Facebook',
      deeplink: 'https://www.facebook.com/hallobumil'
    }, {
      icon: '/images/default/Button-ig.png',
      name: 'Instagram',
      deeplink: 'https://www.instagram.com/hallobumil_id'
    }, {
      icon: '/images/default/Button-tiktok.svg',
      name: 'Tiktok',
      deeplink: 'https://www.tiktok.com/@hallobumil_id'
    }, {
      icon: '/images/default/Button-ytb.png',
      name: 'Youtube',
      deeplink: 'https://www.youtube.com/c/hallobumil'
    }]
  };
  const OS = isAndroid ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isWindows ? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID' : isMacOs ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : isIOS ? 'https://apps.apple.com/id/app/hallobumil/id1507726157' : 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';
  return <>
			<div className={classes.mainFooter}>
				<Row>
					<Col md={12} lg={12} xs={24}>
						<div className={classes.logo}>
							<ImageC width={160} height={40} src="/images/header/logoHallobumil.webp" id="footer-logo-hb" />
						</div>
						<div className={classes['main-section']}>
							<a href={'/syarat-dan-ketentuan-hb'} id="footer-syarat-dan-ketentuan-hb">
								<Typography className={classes.menus}>Syarat dan Ketentuan</Typography>
							</a>

							<a href={'/kebijakan-privasi-hb'} style={{
              cursor: 'pointer'
            }} id="footer-kebijakan-privasi-hb">
								<Typography className={classes.menus}>Kebijakan Privasi</Typography>
							</a>

							<a href={'/cookies-consent-hb'} style={{
              cursor: 'pointer'
            }} id="footer-cookie-consent-hb">
								<Typography className={classes.menus}>Penggunaan Cookie</Typography>
							</a>
							<a href={'/persetujuan-pelanggan-hb'} style={{
              cursor: 'pointer'
            }} id="footer-persetujuan-pelanggan-hb">
								<Typography className={classes.menus}>Persetujuan Pelanggan</Typography>
							</a>
							{/* <a
        href={'/persetujuan-pelanggan-anak-hb'}
        style={{ cursor: 'pointer' }}
        id="footer-persetujuan-pelanggan-anak-hb"
        >
        <Typography className={classes.menus}>Persetujuan Pelanggan (Anak)</Typography>
        </a> */}

							<a href={'/hubungi-kami'} style={{
              cursor: 'pointer'
            }} id="footer-hubungi-kami">
								<Typography className={classes.menus}>Hubungi Kami</Typography>
							</a>
							{/* <div className={classes.store}>
        <Image
        	src="/images/default/logoPlayStore.svg"
        	alt="image"
        	style={{
        		width: sm ? 150 : xs ? 100 : md ? 120 : 150,
        		height: sm ? 38 : xs ? 20 : md ? 25 : 38,
        		cursor: 'pointer',
        	}}
        	preview={false}
        	onClick={() => window.open(OS)}
        	id="footer-play-store"
        />
        <Image
        	src="/images/default/logoAppStore.svg"
        	alt="image"
        	style={{
        		width: sm ? 150 : xs ? 100 : md ? 120 : 150,
        		height: sm ? 38 : xs ? 20 : md ? 25 : 38,
        		cursor: 'pointer',
        	}}
        	preview={false}
        	onClick={() => window.open(OS)}
        	id="footer-app-store"
        />
        </div> */}
							<div className={classes.store}>
								<Image src="/images/branda/hero/logoPlayStore.webp" alt="image" style={{
                width: xs ? 78 : 120,
                height: xs ? 27 : 40,
                cursor: 'pointer'
              }} preview={false} onClick={() => window.open(OS)} id="home-play-store" />
								<span style={{
                margin: '5px'
              }}></span>
								<Image src="/images/branda/hero/logoAppStore.webp" alt="image" style={{
                width: xs ? 78 : 120,
                height: xs ? 27 : 40,
                cursor: 'pointer'
              }} preview={false} onClick={() => window.open(OS)} id="home-app-store" />
							</div>
						</div>
					</Col>
					<Col md={12} lg={12} xs={24}>
						<div className={classes.sectionSosmed}>
							<Paragraph>
								<Typography className={classes.sosmed}>Media Sosial</Typography>
							</Paragraph>
							<Space className={classes.icons} size="middle">
								{sosmed.social_media?.map((item: any) => {
                return <Fragment key={item.name}>
											<a href={item.deeplink} rel="nofollow" id={'footer-' + item.name}>
												{item.icon && <ImageC key={item.name} className={classes['socmed-icon']} width={!xl && lg ? 28 : 32} height={!xl && lg ? 28 : 32} src={item.icon} alt={item.name} style={{
                      cursor: 'pointer'
                    }} />}
											</a>
										</Fragment>;
              })}
							</Space>
						</div>
					</Col>
				</Row>
			</div>
		</>;
};
export default MainFooter;